import { History } from 'history'

import RecaptchaLayout from '@/app/component/layout/recaptcha-page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import LoginForm from '@/app/module/auth/component/login'
import Notifications from '@/app/module/notifications'
import { MatchProps } from '@/app/types'

type Props = {
  history: History
  match: MatchProps
}

export default function SigninPage({ match }: Props) {
  return (
    <AuthGuard url={match.url} path={match.path}>
      <RecaptchaLayout title="Login - engageSPARK">
        <AuthHeader currentPage={PAGE.ACCOUNT.LOGIN} />
        <Notifications />
        <LoginForm />
      </RecaptchaLayout>
    </AuthGuard>
  )
}
